<template>
  <div class="pub-enable-status">
    <span class="s-green" v-if="status == 1">
      <a-icon type="check-circle" />启用
    </span>
    <span class="s-red" v-if="status == 2"> <a-icon type="stop" />禁用</span>
  </div>
</template>

<script>
export default {
  name: "PubEnableStatus",
  props: {
    status: String,
  },
};
</script>

<style scoped lang="less">
@import "~@/assets/style/base.less";
.pub-enable-status {
  i {
    margin-right: 5px;
    position: relative;
    top: 1px;
  }
  .s-green {
    color: @green;
    i {
      color: @green;
    }
  }
  .s-red {
    color: @red;
    i {
      color: @red;
    }
  }
}
</style>
